import loadable from '@loadable/component';

export const ProductTabStatistics = loadable(
  () =>
    import(
      /* webpackChunkName: "product-tab-statistics" */ '../../../product-price-history'
    )
);

export const ProductTabStatisticsLegacyNewUi = loadable(
  () =>
    import(
      /* webpackChunkName: "product-tab-statistics-legacy-new-ui" */ '../../../product-price-history-legacy-new-ui'
    )
);
